<script>
  export default {
    name: 'cache-dispatcher',
    data() {
      return {
        defaultExpiryDuration: 1 * 60 * 60 * 1000, // 1 hour
      }
    },
    methods: {
      dispatch_with_cache(action_name, model_name, records) {
        let cached_at = this.$store.state[action_name]
        if(records && records.length && cached_at.length) {
          let now = this.$moment()
          cached_at = this.$moment(cached_at)
          if(now.diff(cached_at) > this.defaultExpiryDuration) {
            this.$store.dispatch(action_name, model_name)
            this.setCachedAt({ action_name, expires: false })
          }
        } else {
            this.$store.dispatch(action_name, model_name)
            this.setCachedAt({ action_name, expires: false })
        }
      },
      setCachedAt({ action_name, expires }) {
        if(expires) {
          this.$store.state[action_name] = this.$moment().add(- this.defaultExpiryDuration, 'ms').format()
        } else {
          this.$store.state[action_name] = this.$moment().format()
        }
      },
      expiresCache(action_name) {
        this.$store.getters.cacheActionNames.forEach(action_name => this.setCachedAt({ action_name, expires: true }))
      }
    }
  }
</script>
